import React, { useState, useEffect } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import './filter-popup.scss';
import { useTranslation } from 'react-i18next'
import filterIcon from '../../../../assets/images/filter.svg';
import filterActiveIcon from '../../../../assets/images/filter-active.svg';
import {
    formatInputTypeNumber,
    allowNumricOnly,
    validateAWB,
    removeError,
    hasError,
} from '../../../ManageBooking/ListBooking/ListbookingValidations'
import { validateRequired } from '../../../CaptureAWB/captureAwbUtils'
import closeIcon from "../../../../assets/images/close.png";
import AppCalendar from '../../../../common/Calendar'
import { CommonDropDown } from '../../../../common/Resusable/CommonDropDown'
import CommonInput from "../../../../common/Resusable/CommonInput";
import CommonRadioWithLabel from "../../../../common/CommonRadioButton";
import up from "../../../../assets/images/chevron-up.png";
import down from "../../../../assets/images/chevronDown.svg";
const FilterPopup = ({
    op,
    setFilterSummary,
    handleFilterAction,
    maxDate,
    formatDate,
    setAwbRefreshed,
    awbRefreshed,
    setAwbFilter,
    awbFilter,
}) => {
    const { t, i18n } = useTranslation(['labels', 'errors'])
    const [confirmed, setConfirmed] = useState(false);
    const [cancelled, setCancelled] = useState(false);
    const [queued, setQueued] = useState(false);
    const [approved, setApproved] = useState(false);
    const [onHold, setOnHold] = useState(false);
    const [inProgress, setInProgress] = useState(false);
    const [noInformation, setNoInformation] = useState(false);
    const [missingMAWB, setMissingMAWB] = useState(false);
    const [missingHAWB, setMissingHAWB] = useState(false);
    const [notified, setNotified] = useState(false);
    const [notNotified, setNotNotified] = useState(false);
    const [notApplicable, setNotApplicable] = useState(false);
    const [acknowledged, setAcknowledged] = useState(false);
    const [acknowledgementResponse, setAcknowledgementResponse] = useState(false);
    const [escalationAcknowledged, setEscalationAcknowledged] = useState(false);
    const [awbPrefix, setAwbPrefix] = useState('607')
    const [awbNumber, setAwbNumber] = useState('')
    const [error, setError] = useState([])
    const [filterType, setFilterType] = useState('awb-filter')
    const [mismatch, setMismatch] = useState(false);

    const [fmaReceived, setFmaReceived] = useState(false);
    const [fnaReceived, setFnaReceived] = useState(false);
    const [fmaFnaNotacknowledged, setFmaFnaNotAcknowledged] = useState(false);

    const [hsCodeValid, setHsCodeValid] = useState(false);
    const [hsCodeInValid, setHsCodeInValid] = useState(false);
    const [shipmentDescAcceptable, setShipmentDescAcceptable] = useState(false);
    const [shipmentDescUnacceptable, setShipmentDescUnacceptable] = useState(false);
    const [visible, setVisible] = useState(false);
    const getIntialFilter = () => {
        return {
            booking: {
                confirmed,
                queued,
            },
            customs: {
                approved,
                onHold,
                inProgress,
                missingHAWB,
                missingMAWB,
            },
            notification: {
                notified,
                notNotified,
                notApplicable,
            },
            acknowledgement: {
                acknowledged,
                acknowledgementResponse,
                escalationAcknowledged,
            },
            awbFilter: {
                awbPrefix,
                awbNumber,
            },
            fmaFnaAckStatus: {
                fmaReceived,
                fnaReceived,
                fmaFnaNotacknowledged,
            },
            hsCodeStatus: {
                hsCodeValid,
                hsCodeInValid
            }
        }
    }

    const [filterValues, setFilterValues] = useState(getIntialFilter());

    useEffect(() => {
        if (awbRefreshed) {
            setAwbRefreshed(false)
        }
    }, [awbRefreshed])

    const getFilterData = () => {
        let filter = {
            "bookingStatus": getBookingStatus(),
            "customStatus": getCustomStatus(),
            "filterMissingMAWB": missingMAWB,
            "filterMissingHAWB": missingHAWB,
            "notificationStatus": getNotificationStatus(),
            "acknowledgementStatus": getAcknowledgementStatus(),
            fmaFnaAckStatus: getFMAFNAStatusFilter(),
            hsCodeStatus: getHSCodeStatusFilter(),
            shipmentDescriptionStatus: getShipmentStatusDescFilter(),
            airlinePrefix: awbNumber && awbNumber !== '' && awbPrefix && awbPrefix != ''
                ? awbPrefix : null,
            awbNumber: awbNumber && awbNumber !== '' ? awbNumber : null,
            filterMismatch: mismatch,
        }

        let filterData = {
            booking: {
                confirmed,
                queued,
            },
            customs: {
                approved,
                onHold,
                inProgress,
                missingHAWB,
                missingMAWB,
                mismatch,
            },
            notification: {
                notified,
                notNotified,
                notApplicable,
            },
            acknowledgement: {
                acknowledged,
                acknowledgementResponse,
                escalationAcknowledged
            },
            awbFilter: {
                awbPrefix,
                awbNumber,
            },
            fmaFnaAckStatus: {
                fmaReceived,
                fnaReceived,
                fmaFnaNotacknowledged,
            },
            hsCodeStatus: {
                hsCodeValid,
                hsCodeInValid
            },
            shipmentDescriptionStatus: {
                shipmentDescAcceptable,
                shipmentDescUnacceptable
            }
        }
        setFilterValues(filterData)
        setFilterSummary(filter);
        handleFilterAction(filter);

        // Reset filter data if not filter selected
        if (!confirmed && !queued && !approved && !onHold && !inProgress && !missingHAWB && !missingMAWB
            && !notified && !notApplicable && !notNotified && !acknowledged && !acknowledgementResponse && !escalationAcknowledged
            && awbNumber === '' && !fmaReceived && !fnaReceived && !fmaFnaNotacknowledged && !hsCodeValid && !hsCodeInValid && !mismatch) {
            setAwbFilter(null)
        }
    }

    const getBookingStatus = () => {
        let bookingStatus = [];
        if (confirmed) {
            bookingStatus.push('CONFIRMED');
        }
        if (cancelled) {
            bookingStatus.push('CANCELLED');
        }
        if (queued) {
            bookingStatus.push('QUEUED');
        }
        return bookingStatus;
    }

    const getCustomStatus = () => {
        let customStatus = [];
        if (approved) {
            customStatus.push('APPROVED');
        }
        if (onHold) {
            customStatus.push('ONHOLD');
        }
        if (inProgress) {
            customStatus.push('REQUIRED_INFORMATION');
        }
        if (missingMAWB || missingHAWB) {
            customStatus.push('NO_INFORMATION');
        }
        if (mismatch) {
            customStatus.push('MISMATCH')
        }
        return customStatus;
    }

    const getNoInfoStatus = () => {
        let noInfoStatus = [];
        if (missingMAWB) {
            noInfoStatus.push('Missing MAWB');
        }
        if (missingHAWB) {
            noInfoStatus.push('Missing HAWB');
        }
        return noInfoStatus
    }

    const getNotificationStatus = () => {
        let notificationStatus = [];
        if (notified) {
            notificationStatus.push('NOTIFIED');
        }
        if (notNotified) {
            notificationStatus.push('NOT_NOTIFIED');
        }
        if (notApplicable) {
            notificationStatus.push('NOT_APPLICABLE');
        }
        return notificationStatus;
    }

    const getAcknowledgementStatus = () => {
        let acknowledgementStatus = [];
        if (acknowledged) {
            acknowledgementStatus.push('ACKNOWLEDGED');
        }
        if (acknowledgementResponse) {
            acknowledgementStatus.push('NOTACKNOWLEDGED');
        }
        if (escalationAcknowledged) {
            acknowledgementStatus.push('ESCACK');
        }
        return acknowledgementStatus;
    }

    const getFMAFNAStatusFilter = () => {
        let fmaFnaStatusFilter = [];
        if (fmaReceived) {
            fmaFnaStatusFilter.push('FMA_RECEIVED');
        }
        if (fnaReceived) {
            fmaFnaStatusFilter.push('FNA_RECEIVED');
        }
        if (fmaFnaNotacknowledged) {
            fmaFnaStatusFilter.push('NOT_ACK');
        }
        return fmaFnaStatusFilter;
    }

    const getHSCodeStatusFilter = () => {
        let hsCodeStatusFilter = [];
        if (hsCodeValid) {
            hsCodeStatusFilter.push('VALID');
        }
        if (hsCodeInValid) {
            hsCodeStatusFilter.push('INVALID');
        }
        return hsCodeStatusFilter;
    }

    const getShipmentStatusDescFilter = () => {
        let shipmentStatusDescFilter = [];
        if (shipmentDescAcceptable) {
            shipmentStatusDescFilter.push('ACCEPTABLE')
        }
        if (shipmentDescUnacceptable) {
            shipmentStatusDescFilter.push('UNACCEPTABLE')
        }
        return shipmentStatusDescFilter;
    }

    const showFilter = (e) => {
        op.current.toggle(e)
        if (filterValues && filterValues.booking) {
            setConfirmed(filterValues.booking.confirmed)
            setQueued(filterValues.booking.queued)
            if (filterValues.booking.queued || filterValues.booking.confirmed) {
                setFilterType('other-filters')
            }
        }
        if (filterValues && filterValues.customs) {
            setApproved(filterValues.customs.approved)
            setOnHold(filterValues.customs.onHold)
            setInProgress(filterValues.customs.inProgress)
            setMissingHAWB(filterValues.customs.missingHAWB)
            setMissingMAWB(filterValues.customs.missingMAWB)
            setMismatch(filterValues.customs.mismatch)
            if (filterValues.customs.approved || filterValues.customs.onHold
                || filterValues.customs.inProgress || filterValues.customs.missingHAWB
                || filterValues.customs.missingMAWB) {
                setFilterType('other-filters')
            }
        }
        if (filterValues && filterValues.notification) {
            setNotified(filterValues.notification.notified)
            setNotNotified(filterValues.notification.notNotified)
            setNotApplicable(filterValues.notification.notApplicable)
            if (filterValues.notification.notified || filterValues.notification.notNotified
                || filterValues.notification.notApplicable) {
                setFilterType('other-filters')
            }
        }
        if (filterValues && filterValues.acknowledgement) {
            setAcknowledged(filterValues.acknowledgement.acknowledged)
            setAcknowledgementResponse(filterValues.acknowledgement.acknowledgementResponse)
            setEscalationAcknowledged(filterValues.acknowledgement.escalationAcknowledged)
            if (filterValues.acknowledgement.acknowledged || filterValues.acknowledgement.acknowledgementResponse
                || filterValues.acknowledgement.escalationAcknowledged) {
                setFilterType('other-filters')
            }
        }

        if (filterValues && filterValues.fmaFnaAckStatus) {
            setFmaReceived(filterValues.fmaFnaAckStatus.fmaReceived)
            setFnaReceived(filterValues.fmaFnaAckStatus.fnaReceived)
            setFmaFnaNotAcknowledged(filterValues.fmaFnaAckStatus.fmaFnaNotacknowledged)
            if (filterValues.fmaFnaAckStatus.fmaReceived || filterValues.fmaFnaAckStatus.fnaReceived ||
                filterValues.fmaFnaAckStatus.fmaFnaNotacknowledged) {
                setFilterType('other-filters')
            }
        }

        if (filterValues && filterValues.hsCodeStatus) {
            setHsCodeValid(filterValues.hsCodeStatus.hsCodeValid)
            setHsCodeInValid(filterValues.hsCodeStatus.hsCodeInValid)
            if (filterValues.hsCodeStatus.hsCodeValid || filterValues.hsCodeStatus.hsCodeInValid) {
                setFilterType('other-filters')
            }
        }
        if (filterValues && filterValues.shipmentDescriptionStatus) {
            setShipmentDescAcceptable(filterValues.shipmentDescriptionStatus.shipmentDescAcceptable)
            setShipmentDescUnacceptable(filterValues.shipmentDescriptionStatus.shipmentDescUnacceptable)
            if (filterValues.shipmentDescriptionStatus.shipmentDescAcceptable || filterValues.shipmentDescriptionStatus.shipmentDescUnacceptable) {
                setFilterType('other-filters')
            }
        }


        if (filterValues && filterValues.awbFilter) {
            setAwbPrefix(filterValues.awbFilter.awbPrefix)
            setAwbNumber(filterValues.awbFilter.awbNumber)
            if (filterValues?.awbFilter?.airlinePrefix
                && filterValues?.awbFilter?.awbNumber) {
                setFilterType('awb-filter')
            }
        }
        if (awbFilter && awbFilter.airlinePrefix && awbFilter.airlinePrefix !== ''
            && awbFilter.awbNumber && awbFilter.awbNumber !== '') {
            setAwbPrefix(awbFilter.airlinePrefix)
            setAwbNumber(awbFilter.awbNumber)
            setFilterType('awb-filter')
        }
        setError([])
    }

    const handleConfirmed = () => {
        setConfirmed(!confirmed);
    }

    const handleCancelled = () => {
        setCancelled(!cancelled);
    }

    const handleQueued = () => {
        setQueued(!queued);
    }

    const handleApproved = () => {
        setApproved(!approved);
    }

    const handleOnHold = () => {
        setOnHold(!onHold)
    }

    const handleReqInfo = () => {
        setInProgress(!inProgress)
    }

    const handleNoInfo = () => {
        setNoInformation(!noInformation)
    }

    const handleMissingMAWB = () => {
        setMissingMAWB(!missingMAWB)
    }

    const handleMissingHAWB = () => {
        setMissingHAWB(!missingHAWB)
    }

    const handleMismatch = () => {
        setMismatch(!mismatch)
    }

    const handleNotified = () => {
        setNotified(!notified)
    }

    const handleNotNotified = () => {
        setNotNotified(!notNotified)
    }

    const handleNotApplicable = () => {
        setNotApplicable(!notApplicable)
    }

    const handleAcknowledgementResponse = () => {
        setAcknowledgementResponse(!acknowledgementResponse)
    }

    const handleAcknowledged = () => {
        setAcknowledged(!acknowledged)
    }

    const handleEscalationAcknowledged = () => {
        setEscalationAcknowledged(!escalationAcknowledged)
    }

    const clearFilterStates = (filterTypeChanged) => {
        setError(null);
        setConfirmed(false);
        setCancelled(false);
        setQueued(false);
        setApproved(false);
        setOnHold(false);
        setMissingMAWB(false)
        setMissingHAWB(false)
        setNotified(false);
        setNotNotified(false);
        setNotApplicable(false);
        setAcknowledged(false);
        setAcknowledgementResponse(false);
        setEscalationAcknowledged(false);
        setInProgress(false)
        setAwbPrefix('607')
        setAwbNumber('')
        setFmaReceived(false)
        setFnaReceived(false)
        setFmaFnaNotAcknowledged(false)

        setHsCodeValid(false)
        setHsCodeInValid(false)
        setMismatch(false)

        if (!filterTypeChanged) {
            setFilterType('awb-filter')
        }
    }


    const onFilter = (e) => {
        getFilterData();

    }

    const handleChangeOfAWB = (value) => {
        if (value.length <= 8) {
            setAwbNumber(value)
        }
    }

    return (
        <li className='csn_filter__item_awb'>
            <div className={`showFilter csn-filter filter-link mt-3 mb-4 ${awbFilter ? 'active' : ''}`} onClick={(e) => showFilter(e)}>
                <label className="filter-label">{t("COMMON.FILTERS")}</label>
                <img src={visible ? up : down} className="chev-icon" alt="chev-icon" />
            </div>

            <div className='b-none d-lg-block'>

                <OverlayPanel
                    ref={op}
                    className='custom_overlay_panel placi-filter'
                    appendTo={document.body}
                >
                    <div className="overlay-header">
                        <img src={closeIcon} alt="close" onClick={(e) => {
                            op.current.hide(e)
                            setFilterSummary({})
                        }} className='close-img'></img>

                    </div>
                    <div className='awb-details-filter-container'>
                        <div className='search-awb-container cargo-portal-container'>
                            <CommonRadioWithLabel
                                checked={filterType && filterType === 'awb-filter' ? true : false}
                                id='awb-filter' type='radio' value='awb-filter' name='filter-choice'
                                aria-invalid='false' pattern='[a-zA-Z]' aria-describedby='input-radio-description'
                                onChange={(e) => {
                                    setFilterType(e.target.value)
                                    clearFilterStates(true)
                                }}
                                className={`radio-toggle-second `}
                                label="Search AWB number"

                            />
                            <div className={`form-group awb-input-section mb-0 ${filterType && filterType !== 'awb-filter' ? 'disable-time-selection' : ''}`}>
                                <CommonInput
                                    type="text"

                                    label={t("COMMON.PREFIX")}
                                    aria-invalid={hasError('awbPrefix', error)}
                                    value={awbPrefix}
                                    maxLength='3'
                                    onKeyPress={(evt) => {
                                        return allowNumricOnly(evt)
                                    }}
                                    onChange={(e) => {
                                        setAwbPrefix(e.target.value)
                                    }}
                                    onFocus={(e) => {
                                        removeError(e, setError)
                                    }}
                                    onBlur={(e) => {
                                    }}
                                    error={error && error['awbPrefix']
                                        ? t(error['awbPrefix'], { ns: 'errors' })
                                        : ''}
                                    wrapperClassName={`awb-prefix`}
                                />

                                <CommonInput
                                    type="text"
                                    label={t('COMMON.AWB_NUMBER')}
                                    aria-invalid={hasError('awbNumber', error)}

                                    value={awbNumber}
                                    onKeyPress={(evt) => {
                                        return allowNumricOnly(evt)
                                    }}
                                    onKeyDown={(evt) => formatInputTypeNumber(evt)}
                                    onChange={(e) => handleChangeOfAWB(e.target.value)}
                                    onBlur={(e) => {
                                        validateAWB(e.target.value, setError, 'awbNumber')
                                        if (e.target.value !== '') {
                                            validateRequired(awbPrefix, setError, 'awbPrefix')
                                        }
                                    }}
                                    onFocus={(e) => {
                                        removeError(e, setError)
                                    }}
                                    error={error && error['awbNumber']
                                        ? t(error['awbNumber'], { ns: 'errors' })
                                        : ''}
                                    wrapperClassName={"awb-suffix"}
                                />
                            </div>
                        </div>

                        <div className='search-awb-container cargo-portal-container'>
                            <CommonRadioWithLabel

                                id='other-filters' type='radio' value='other-filters' name='filter-choice'
                                aria-invalid='false' pattern='[a-zA-Z]' aria-describedby='input-radio-description'
                                checked={filterType && filterType === 'other-filters' ? true : false}
                                onChange={(e) => {
                                    setFilterType(e.target.value)
                                    clearFilterStates(true)
                                }}
                                className={`radio-toggle-second `}
                                label="Other filters"

                            />
                            <div className={`check-box-container ${filterType} ${filterType && filterType !== 'other-filters' ? 'disable-time-selection' : ''}`}>
                                <div className='bokking-status-container'>
                                    <div className='status-heading'>Booking Status</div>
                                    <div className="l-checkbox ">
                                        <input
                                            id='confirmed'
                                            type='checkbox'
                                            name='confirmed'
                                            // className='checkbox-item__field'
                                            aria-describedby='confirmed'
                                            onChange={handleConfirmed}
                                            checked={confirmed}

                                        />
                                        <label className="mb-0 fw-normal" htmlFor='confirmed'>
                                            Confirmed
                                        </label>
                                    </div>
                                    <div className="l-checkbox ">
                                        <input
                                            id='queued'
                                            type='checkbox'
                                            name='queued'
                                            aria-describedby='queued'
                                            onChange={handleQueued}
                                            checked={queued}

                                        />
                                        <label className="mb-0 fw-normal" htmlFor='queued'>
                                            Queued
                                        </label>
                                    </div>
                                </div>

                                <div className='bokking-status-container'>
                                    <div className='status-heading'>Customs Status</div>
                                    <div className="l-checkbox ">
                                        <input
                                            id='approved'
                                            type='checkbox'
                                            name='approved'
                                            aria-describedby='approved'
                                            onChange={handleApproved}
                                            checked={approved}

                                        />
                                        <label className="mb-0" htmlFor='approved'>
                                            Cleared
                                        </label>
                                    </div>
                                    <div className="l-checkbox ">
                                        <input
                                            id='onHold'
                                            type='checkbox'
                                            name='onHold'
                                            aria-describedby='onHold'
                                            onChange={handleOnHold}
                                            checked={onHold}

                                        />
                                        <label className="mb-0 " htmlFor='onHold'>
                                            On hold
                                        </label>
                                    </div>
                                    <div className="l-checkbox ">
                                        <input
                                            id='in-progress'
                                            type='checkbox'
                                            name='in-progress'
                                            aria-describedby='in-progress'
                                            onChange={handleReqInfo}
                                            checked={inProgress}

                                        />
                                        <label className="mb-0 " htmlFor='in-progress'>
                                            Under assessment by NAIC
                                        </label>
                                    </div>
                                    <div className="l-checkbox ">
                                        <input
                                            id='no-info-mawb'
                                            type='checkbox'
                                            name='no-info-mawb'
                                            aria-describedby='no-info-mawb'
                                            onChange={handleMissingMAWB}
                                            checked={missingMAWB}

                                        />
                                        <label className="mb-0 " htmlFor='no-info-mawb'>
                                            Missing MAWB
                                        </label>
                                    </div>
                                    <div className="l-checkbox ">
                                        <input
                                            id='no-info-hawb'
                                            type='checkbox'
                                            name='no-info-hawb'
                                            aria-describedby='no-info-hawb'
                                            onChange={handleMissingHAWB}
                                            checked={missingHAWB}
                                        />
                                        <label className="mb-0 " htmlFor='no-info-hawb'>
                                            Missing HAWB
                                        </label>
                                    </div>
                                    <div className="l-checkbox ">
                                        <input
                                            id='mawb-mismatch'
                                            type='checkbox'
                                            name='mawb-mismatch'
                                            aria-describedby='mawb-mismatch'
                                            onChange={handleMismatch}
                                            checked={mismatch}
                                        />
                                        <label className="mb-0 " htmlFor='mawb-mismatch'>
                                            Mismatch(Pcs/Wgt)
                                        </label>
                                    </div>
                                </div>
                                <div className='bokking-status-container'>
                                    <div className='status-heading'>FMA/FNA Status</div>
                                    <div className="l-checkbox ">
                                        <input
                                            id='fmaReceived'
                                            type='checkbox'
                                            name='fmaReceived'

                                            aria-describedby='fmaReceived'
                                            onChange={() => {
                                                setFmaReceived(!fmaReceived)
                                            }}
                                            checked={fmaReceived}
                                        />
                                        <label className="mb-0 " htmlFor='fmaReceived'>
                                            FMA received
                                        </label>
                                    </div>
                                    <div className="l-checkbox ">
                                        <input
                                            id='fnaReceived'
                                            type='checkbox'
                                            name='fnaReceived'
                                            aria-describedby='fnaReceived'
                                            onChange={() => {
                                                setFnaReceived(!fnaReceived)
                                            }}
                                            checked={fnaReceived}
                                        />
                                        <label className="mb-0 " htmlFor='fnaReceived'>
                                            FNA received
                                        </label>
                                    </div>
                                    <div className="l-checkbox ">
                                        <input
                                            id='fmaFnaNotAcknowledged'
                                            type='checkbox'
                                            name='fmaFnaNotAcknowledged'

                                            aria-describedby='fmaFnaNotAcknowledged'
                                            onChange={() => {
                                                setFmaFnaNotAcknowledged(!fmaFnaNotacknowledged)
                                            }}
                                            checked={fmaFnaNotacknowledged}
                                        />
                                        <label className="mb-0 " htmlFor='fmaFnaNotAcknowledged'>
                                            Not acknowledged
                                        </label>
                                    </div>

                                </div>
                                <div className='bokking-status-container'>
                                    <div className='status-heading'>HS code status</div>
                                    <div className="l-checkbox ">
                                        <input
                                            id='hsCodeValid'
                                            type='checkbox'
                                            name='hsCodeValid'

                                            aria-describedby='hsCodeValid'
                                            onChange={() => {
                                                setHsCodeValid(!hsCodeValid)
                                            }}
                                            checked={hsCodeValid}
                                        />
                                        <label className="mb-0 " htmlFor='hsCodeValid'>
                                            Valid
                                        </label>
                                    </div>
                                    <div className="l-checkbox ">
                                        <input
                                            id='hsCodeInValid'
                                            type='checkbox'
                                            name='hsCodeInValid'

                                            aria-describedby='hsCodeInValid'
                                            onChange={() => {
                                                setHsCodeInValid(!hsCodeInValid)
                                            }}
                                            checked={hsCodeInValid}
                                        />
                                        <label className="mb-0 " htmlFor='hsCodeInValid'>
                                            Invalid
                                        </label>
                                    </div>
                                </div>
                                <div className='bokking-status-container'>
                                    <div className='status-heading'>Acknowledgement Status</div>
                                    <div className="l-checkbox ">
                                        <input
                                            id='acknowledged'
                                            type='checkbox'
                                            name='acknowledged'
                                            aria-describedby='acknowledged'
                                            onChange={handleAcknowledged}
                                            checked={acknowledged}
                                        />
                                        <label className="mb-0 " htmlFor='acknowledged'>
                                            Ack by GHA
                                        </label>
                                    </div>
                                    <div className="l-checkbox ">
                                        <input
                                            id='acknowledgementResponse'
                                            type='checkbox'
                                            name='response'
                                            aria-describedby='acknowledgementResponse'
                                            onChange={handleAcknowledgementResponse}
                                            checked={acknowledgementResponse}
                                        />
                                        <label className="mb-0 " htmlFor='acknowledgementResponse'>
                                            Not Ack by GHA
                                        </label>
                                    </div>
                                    <div className="l-checkbox ">
                                        <input
                                            id='escalationAcknowledged'
                                            type='checkbox'
                                            name='escalationAcknowledged'

                                            aria-describedby='escalationAcknowledged'
                                            onChange={handleEscalationAcknowledged}
                                            checked={escalationAcknowledged}
                                        />
                                        <label className="mb-0 " htmlFor='escalationAcknowledged'>
                                            Escln ack by ACI
                                        </label>
                                    </div>
                                </div>
                                <div className='bokking-status-container'>
                                    <div className='status-heading'>Notification Status</div>
                                    <div className="l-checkbox ">
                                        <input
                                            id='notified'
                                            type='checkbox'
                                            name='notified'
                                            aria-describedby='notified'
                                            onChange={handleNotified}
                                            checked={notified}
                                        />
                                        <label className="mb-0 " htmlFor='notified'>
                                            Notified
                                        </label>
                                    </div>
                                    <div className="l-checkbox ">
                                        <input
                                            id='notNotified'
                                            type='checkbox'
                                            name='notNotified'
                                            aria-describedby='notNotified'
                                            onChange={handleNotNotified}
                                            checked={notNotified}
                                        />
                                        <label className="mb-0 " htmlFor='notNotified'>
                                            Not Notified
                                        </label>
                                    </div>
                                    <div className="l-checkbox ">
                                        <input
                                            id='notApplicable'
                                            type='checkbox'
                                            name='notApplicable'
                                            aria-describedby='notApplicable'
                                            onChange={handleNotApplicable}
                                            checked={notApplicable}
                                        />
                                        <label className="mb-0 " htmlFor='notApplicable'>
                                            Not Applicable
                                        </label>
                                    </div>
                                </div>
                                <div className='bokking-status-container'>
                                    <div className='status-heading'>Shipment Description</div>
                                    <div className="l-checkbox ">
                                        <input
                                            id='shipmentDescAcceptable'
                                            type='checkbox'
                                            name='shipmentDescAcceptable'

                                            aria-describedby='shipmentDescAcceptable'
                                            onChange={() => {
                                                setShipmentDescAcceptable(!shipmentDescAcceptable)
                                            }}
                                            checked={shipmentDescAcceptable}
                                        />
                                        <label className="mb-0 " htmlFor='shipmentDescAcceptable'>
                                            Acceptable
                                        </label>
                                    </div>
                                    <div className="l-checkbox ">
                                        <input
                                            id='shipmentDescUnacceptable'
                                            type='checkbox'
                                            name='shipmentDescUnacceptable'

                                            aria-describedby='shipmentDescUnacceptable'
                                            onChange={() => {
                                                setShipmentDescUnacceptable(!shipmentDescUnacceptable)
                                            }}
                                            checked={shipmentDescUnacceptable}
                                        />
                                        <label className="mb-0 " htmlFor='shipmentDescUnacceptable'>
                                            Unacceptable
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className='filter-footer-container'>
                            <button
                                type='button'
                                className='clear-button'
                                onClick={() => clearFilterStates()}
                            >
                                Reset all
                            </button>
                            <button
                                type='button'
                                disabled={filterType && filterType === 'awb-filter' && hasError('awbNumber', error) ? true : false}
                                className='filter-button'
                                onClick={(e) => {
                                    onFilter(e)
                                    op.current.hide(e)
                                }
                                }
                            >
                                {t('COMMON.FILTER')}
                            </button>

                        </div>
                    </div>


                </OverlayPanel>
            </div>
        </li>
    )
}

export default FilterPopup;